import HotelsConn from './containers/HotelsConn';
import HotelSideBarConn from './containers/HotelSideBarConn';

export {
  HotelsConn,
  HotelSideBarConn
};